import { render, staticRenderFns } from "./PageEventSchool.vue?vue&type=template&id=10eb5803&scoped=true&"
import script from "./PageEventSchool.vue?vue&type=script&lang=js&"
export * from "./PageEventSchool.vue?vue&type=script&lang=js&"
import style0 from "./PageEventSchool.vue?vue&type=style&index=0&id=10eb5803&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eb5803",
  null
  
)

export default component.exports